module.exports = __webpack_public_path__ + "img/s8sLogo6.086dfff2.png";